export default {
  "account-header-layout": () => import("/vercel/path0/layouts/AccountHeaderLayout.vue").then(m => m.default || m),
  "account-layout": () => import("/vercel/path0/layouts/AccountLayout.vue").then(m => m.default || m),
  footer: () => import("/vercel/path0/layouts/Footer.vue").then(m => m.default || m),
  "page-footer-layout": () => import("/vercel/path0/layouts/PageFooterLayout.vue").then(m => m.default || m),
  "page-header-layout": () => import("/vercel/path0/layouts/PageHeaderLayout.vue").then(m => m.default || m),
  "page-layout": () => import("/vercel/path0/layouts/PageLayout.vue").then(m => m.default || m),
  "page-menu-layout": () => import("/vercel/path0/layouts/PageMenuLayout.vue").then(m => m.default || m),
  "post-layout": () => import("/vercel/path0/layouts/PostLayout.vue").then(m => m.default || m),
  "timeline-layout": () => import("/vercel/path0/layouts/TimelineLayout.vue").then(m => m.default || m)
}